import React from "react";
import "./ContentZone.css";

function ContentZone({ 
  imageSide = "left", // "left" or "right"
  image,
  children,
  className = ""
}) {
  return (
    <div className={`content-zone ${imageSide === "right" ? "image-right" : "image-left"} ${className}`}>
      {imageSide === "left" && (
        <div className="content-zone-image">
          {image}
        </div>
      )}
      <div className="content-zone-text">
        {children}
      </div>
      {imageSide === "right" && (
        <div className="content-zone-image">
          {image}
        </div>
      )}
    </div>
  );
}

export default ContentZone;

